import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = {
  key: 1,
  class: "row"
}
const _hoisted_3 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = { class: "row gx-4 gx-lg-5 row-cols-1 row-cols-md-2 row-cols-xl-3 row-cols-xxl-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-arrow-left",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
  })
], -1)

import { computed, ref } from 'vue';
    import { ArticleViewModel } from '@/types/ArticleViewModel';
    import { CategoryViewModel } from '@/types/CategoryViewModel';
    import ArticleCard from '@/components/ArticleCard.vue';
    import Categories from '@/components/Categories.vue';
    import SuitsFor from '@/components/SuitsFor.vue';
    import { articleApi } from '@/services/article.service';

    import { useRootStore } from '@/store/root.store';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'ArticleListByModel',
  props: {
    categoryId: null,
    modelId: null,
    excludeArticleIds: null,
    showSold: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { categoryId: number, modelId: number, excludeArticleIds: number[], showSold: boolean }

    const rootStore = useRootStore();

    
    
    const texts = ref({
        2: {
            header: 'Knivar av samma modell',
            backButtonText: 'TILLBAKA TILL ALLA KNIVAR',
            path: '/knivar'
        },
        3: {
            header: 'Några tidigare projekt',
            backButtonText: 'TILLBAKA TILL ALLA FODRAL',
            path: '/fodral'
        },
        4: {
            header: 'Några tidigare projekt',
            backButtonText: 'TILLBAKA TILL SKRÄDDARSYTT',
            path: '/skraddarsytt'
        }
    });

    const filteredArticlesByModel = computed(() => {
        if (rootStore.hasLoadedArticles) {
            let articles = rootStore.articles.filter(x => x.modelId === props.modelId && !props.excludeArticleIds.includes(x.id));
            if (!props.showSold) {
                articles = articles.filter(x => !x.isSold);
            }

            return articles;
        }

        return [];
    });

    //const fetchArticles = async () => {
    //    if (!rootStore.hasLoadedArticles) {
    //        rootStore.setArticles(await articleApi.getAllActive());
    //    }
    //    filteredArticlesByModel.value = rootStore.articles.filter(x => x.modelId === props.modelId && !x.isSold);
    //};

    //fetchArticles();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", null, [
    (!_unref(rootStore).hasLoadedArticles)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    (_unref(rootStore).hasLoadedArticles)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_unref(filteredArticlesByModel).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("h2", _hoisted_4, _toDisplayString(texts.value[__props.categoryId].header), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredArticlesByModel), (article) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "col mb-5 cursor-pointer",
                key: article.id
              }, [
                _createVNode(ArticleCard, {
                  article: article,
                  heightClass: 'h-100'
                }, null, 8, ["article"])
              ]))
            }), 128))
          ]),
          _createVNode(_component_router_link, {
            to: { path: texts.value[__props.categoryId].path }
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                class: "btn btn-outline-primary btn-custom-size",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigate && _ctx.navigate(...args)))
              }, [
                _hoisted_6,
                _createTextVNode(" " + _toDisplayString(texts.value[__props.categoryId].backButtonText), 1)
              ])
            ]),
            _: 1
          }, 8, ["to"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})